class NovCatalogReviews {
    constructor(options = {}){    
        this.options = Object.assign(
            {},
            {    
                trads : {}
            }, 
            options
        ); 
        this.reviewsMin = document.querySelectorAll(".content-reviews-min"); 
        this.getReviews();    
    }  

    async getReviews(){  
         
        const call3 = await fetch(`${app.aws.url}/json/reviews`);
        const rep3 = await call3.json();    
        this.reviewsMin.forEach(r => {
            let ids = JSON.parse(r.getAttribute("data-id")); 
            if(ids.length > 1){
                let total = 0;
                let rating = 0;
                let count = 0;
                ids.forEach(id => {
                    console.log(id);
                    let dataPrd = rep3.data.products[id]; 
                    if(typeof dataPrd != "undefined"){
                        count++;
                        total+=dataPrd.total;
                        rating+=dataPrd.rating;
                    }
                });
                let nRating = rating / count; 
                if(count > 0){
                    this.buildScoreReviewsMin(nRating, total, r); 
                }
            }else{
                let dataPrd = rep3.data.products[ids[0]]; 
                if(typeof dataPrd != "undefined"){
                    this.buildScoreReviewsMin(dataPrd.rating, dataPrd.total, r); 
                }
            }
        });
          
    } 

    buildScoreReviewsMin(score, count, target){   
        var noteT = parseInt(score);
        var noteR = Number(score); 
        var noteE = Math.floor((noteR - noteT) * 10) / 10;   
        if(noteE !== 0){
            var decimal = true;
        }else{
            var decimal = false;
        } 
        for(let i = 1; i <= noteT; i++){
            target.querySelector(".star:nth-child(" + i + ")").classList.add("active");
        }
        if(decimal){ 
            target.querySelector(".star:nth-child(" + (noteT + 1) + ")").classList.add("active-s-"+(noteE*10)); 
        }   
        if(target.querySelector(".note") != null){
            target.querySelector(".note").innerHTML = score.toFixed(1) + "/5"; 
        }
        if(target.querySelector(".count") != null){
            target.querySelector(".count").innerHTML = count + " " + this.options.trads.reviews; 
        }
    }  
}  